import { render } from "./OthersConfirm.vue?vue&type=template&id=345767b5&scoped=true&ts=true"
import script from "./OthersConfirm.vue?vue&type=script&lang=ts"
export * from "./OthersConfirm.vue?vue&type=script&lang=ts"

import "./OthersConfirm.vue?vue&type=style&index=0&id=345767b5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345767b5"]])

export default __exports__